/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  QueuesRestricted,
  QueuesRestrictedInterface,
  QueuesConstructor,
} from "../QueuesRestricted";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "DeleteQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct Queue.Struct",
        name: "queue",
        type: "tuple",
      },
    ],
    name: "EditQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "player",
        type: "address",
      },
    ],
    name: "PlayerEnqueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "QueueClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "idStart",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "idStop",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct Queue.Struct[]",
        name: "newQueues",
        type: "tuple[]",
      },
    ],
    name: "QueuesCreation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "Unenqueue",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "closeQueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "queues",
        type: "address",
      },
      {
        internalType: "address",
        name: "zerocost",
        type: "address",
      },
      {
        internalType: "address",
        name: "arenas",
        type: "address",
      },
      {
        internalType: "address",
        name: "hounds",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "races",
        type: "address",
      },
      {
        internalType: "address",
        name: "raceUploader",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        internalType: "struct Queue.Struct[]",
        name: "createdQueues",
        type: "tuple[]",
      },
    ],
    name: "createQueues",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        internalType: "struct Queue.Struct",
        name: "queue",
        type: "tuple",
      },
    ],
    name: "editQueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "enqueueDatesOf",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "participantsOf",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "queue",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "address",
                name: "feeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "raceEntryTicketCurrency",
                type: "address",
              },
              {
                internalType: "uint256[]",
                name: "participants",
                type: "uint256[]",
              },
              {
                internalType: "uint256[]",
                name: "enqueueDates",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "arena",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "raceEntryTicket",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
              },
            ],
            internalType: "struct Core.Struct",
            name: "core",
            type: "tuple",
          },
          {
            internalType: "uint256[]",
            name: "speciesAllowed",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "startDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCompletion",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "totalParticipants",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "cooldown",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCost",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "closed",
            type: "bool",
          },
        ],
        internalType: "struct Queue.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "queues",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "address",
            name: "feeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceEntryTicketCurrency",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "participants",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "enqueueDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "arena",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "raceEntryTicket",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct Core.Struct",
        name: "core",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "startDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastCompletion",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "totalParticipants",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "cooldown",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "staminaCost",
        type: "uint32",
      },
      {
        internalType: "bool",
        name: "closed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "queues",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "arenas",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "raceUploader",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct QueuesConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "staminaCostOf",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type QueuesRestrictedConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: QueuesRestrictedConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class QueuesRestricted__factory extends ContractFactory {
  constructor(...args: QueuesRestrictedConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "QueuesRestricted";
  }

  deploy(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<QueuesRestricted> {
    return super.deploy(input, overrides || {}) as Promise<QueuesRestricted>;
  }
  getDeployTransaction(
    input: QueuesConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): QueuesRestricted {
    return super.attach(address) as QueuesRestricted;
  }
  connect(signer: Signer): QueuesRestricted__factory {
    return super.connect(signer) as QueuesRestricted__factory;
  }
  static readonly contractName: "QueuesRestricted";
  public readonly contractName: "QueuesRestricted";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): QueuesRestrictedInterface {
    return new utils.Interface(_abi) as QueuesRestrictedInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): QueuesRestricted {
    return new Contract(address, _abi, signerOrProvider) as QueuesRestricted;
  }
}
